<template>
  <div>
    <header-bar>
      {{ type === 'album' ? 'アルバム（2曲以上）': 'シングル' }}配信
    </header-bar>
    <div class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">リリース情報登録 - 歌詞情報の登録</h3>
        <release-type-label :type="type" />
      </div>
      <div class="page-block__inner">
        <release-step-area :index="2">
          歌詞情報の登録
        </release-step-area>
      </div>
      <alert-view
        :errors="errors" />
      <div>
        <ul class="c-indent-list">
          <li class="c-indent-list__node">
            歌唱通りの歌詞のみを入力し、歌詞以外の文字やタイトル、アーティスト名、著作者（作詞者・作曲者など）は入力しないでください。
          </li>
          <li class="c-indent-list__node">
            歌唱を繰り返す部分では（Repeat）等の表記は使わず、歌唱どおりに繰り返す部分も全て歌詞を記載して下さい。
          </li>
          <li class="c-indent-list__node">
            フェイクやコーラスなどの歌唱パートも記載して下さい。
          </li>
          <li class="c-indent-list__node">
            歌詞入力の注意事項は
            <a
              :href="isBtoB ? 'https://cmap.zula.jp/client/faqs/119' : 'https://narasu.jp/client/faqs/118'"
              target="_blank"
              class="c-text-link">
              こちら
            </a>
          </li>
        </ul>
      </div>
      <form class="form--error">
        <div class="form-wrap">
          <div class="form-group">
            <div class="form-label form-label--top">
              <label
                class="control-label"
                for="lyrics">歌詞情報
              </label>
            </div>
            <div class="form-item">
              <textarea
                id="lyrics"
                v-model="lyrics"
                class="form-control c-textarea c-lyrics-form">
              </textarea>
              <p
                v-if="errors.lyrics"
                class="error-text">
                {{ errors.lyrics[0] }}
              </p>
            </div>
          </div>
        </div>
      </form>
      <div class="c-btn-wrap">
        <a
          class="c-btn c-btn--back c-btn--back-left"
          href="#"
          @click.prevent="onReturnClicked">
          戻る
          <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
        </a>
        <a
          class="c-btn"
          href="#"
          @click.prevent="onSaveClicked">
          <span>歌詞を保存する</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../../HeaderBar'
import ReleaseTypeLabel from '../ReleaseTypeLabel'
import ReleaseStepArea from '../StepArea'
import AlertView from '../../AlertView'

export default {
  name: 'ReleaseLyricsSimpleForm',
  components: {
    AlertView,
    ReleaseStepArea,
    ReleaseTypeLabel,
    HeaderBar,
  },
  data() {
    return {
      errors: {},
      type: '',
      lyrics: '',
      originalLyrics: [],
    }
  },
  watch: {
    lyrics() {
      this.errors = {}
    },
  },
  mounted() {
    // セッションストレージから一時保存されたデータを読み込み
    const release = JSON.parse(window.sessionStorage.getItem('album'))
    if (!release) {
      this.$router.push({ name: 'index' })
      return
    }
    this.type = release.type
    this.fetchLyrics()
  },

  methods: {
    async fetchLyrics() {
      const release = JSON.parse(window.sessionStorage.getItem('album'))
      const { discIndex, trackIndex } = this.$route.params
      const { data } = await window.axios.get(`/api/client/products/${release.product.id}/disc/${discIndex}/track/${trackIndex}/lyrics`)
      let lyricText = ''
      if (data.lyrics?.startsWith('{"lines"')) {
        const parsedLyrics = JSON.parse(data.lyrics)
        if (parsedLyrics.lines) {
          parsedLyrics.lines.forEach((line, index, array) => {
            this.originalLyrics.push([
              line.words[0].start / 1000,
              line.words[0].str,
            ])
            if (index === array.length - 1) lyricText += `${line.words[0].str || ''}`
            else lyricText += `${line.words[0].str || ''}\n`
          })
        }
        lyricText.substring(0, lyricText.length - 2)
        this.lyrics = lyricText
      } else {
        this.originalLyrics = ''
        this.lyrics = data.lyrics ?? ''
      }
    },
    onReturnClicked() {
      const { discIndex, trackIndex } = this.$route.params
      this.$router.push({
        name: `${this.$route.meta.sideMenuId}-step2-lyrics`,
        hash: `#disc${discIndex}-track${trackIndex}`,
        params: {
          isBackMode: true,
        },
      })
    },
    onSaveReturnClicked() {
      const { discIndex, trackIndex } = this.$route.params
      this.$router.push({
        name: `${this.$route.meta.sideMenuId}-step2`,
        hash: `#disc${discIndex}-track${trackIndex}`,
      })
    },
    async onSaveClicked() {
      try {
        const release = JSON.parse(window.sessionStorage.getItem('album'))
        const { discIndex, trackIndex } = this.$route.params
        const saveData = {}
        let lines = []
        if (this.lyrics === '') lines = null
        else {
          const currentLyric = this.lyrics.split('\n')
          currentLyric.forEach((line, index) => {
            lines.push({
              start: this.originalLyrics[index]
                ? parseInt(Math.round(this.originalLyrics[index][0] * 1000), 10)
                : null,
              words: [
                {
                  start: this.originalLyrics[index]
                    ? parseInt(Math.round(this.originalLyrics[index][0] * 1000), 10)
                    : null,
                  str: line || '',
                },
              ],
            })
          })
        }
        this.$set(saveData, 'lines', lines)
        await window.axios.post(`/api/client/products/${release.product.id}/disc/${discIndex}/track/${trackIndex}/lyrics`, {
          lyrics: JSON.stringify(saveData),
          lyrics_type: 1,
        })
        release.discs[discIndex].tracks[trackIndex].lyrics_type = 1
        window.sessionStorage.setItem('album', JSON.stringify(release))
        const LyricsErrors = JSON.parse(window.sessionStorage.getItem('hasLyricsError') || '{}')
        LyricsErrors[`${discIndex}-${trackIndex}`] = false
        window.sessionStorage.setItem('hasLyricsError', JSON.stringify(LyricsErrors))
        const LyricsCompletePercentages = JSON.parse(window.sessionStorage.getItem('lyricsCompletePercentage') || '{}')
        LyricsCompletePercentages[`${discIndex}-${trackIndex}`] = 0
        window.sessionStorage.setItem('lyricsCompletePercentage', JSON.stringify(LyricsCompletePercentages))
        this.onSaveReturnClicked()
      } catch ({ response }) {
        const { errors } = response.data
        this.errors = errors
        window.scrollTo(0, 0)
      }
    },
  },
}
</script>

<style scoped>
@media screen and (min-width: 896px) {
  .c-btn-wrap {
    margin: 0 20px 0 20px
  }
  .c-lyrics-form {
    height: 40vh;
  }
  .c-indent-list {
    padding: 10px 40px 10px;
  }
}
@media screen and (max-width: 896px) {
  .c-lyrics-form {
    height: 80vh;
  }
  .c-indent-list {
    padding: 10px 20px 10px;
  }
}
</style>
